import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RatingProps {
  value: number;
  max?: number;
  size?: 'sm' | 'md';
  className?: string;
}

export function Rating({ value, max = 5, size = 'md', className }: RatingProps) {
  const iconSize = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';

  return (
    <div className={cn('flex gap-0.5', className)}>
      {Array.from({ length: max }, (_, i) => (
        <Star
          key={i}
          className={cn(
            iconSize,
            i < value ? 'fill-warning text-warning' : 'fill-grey-200 text-grey-200',
          )}
        />
      ))}
    </div>
  );
}
